import { useEffect } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { Icon } from "./icons.jsx";

const OPTIONS = [
  { action: "switch", icon: "repeat", title: strings.switchAccount, hint: strings.switchAccountHint },
  { action: "logout", icon: "log-out", title: strings.logout, hint: strings.logoutHint }
];

// Bottom-sheet que abre el chip de la cuenta del header (mismo estilo que
// ListPicker). Sólo elige la acción: la confirmación la pide ChatScreen.
export function AccountMenu({ accountLabel, onChoose, onCancel }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onCancel]);

  return (
    <div class="fixed inset-0 z-20 flex items-end bg-black/40" onClick={onCancel}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={strings.accountMenu}
        class="w-full rounded-t-2xl bg-white p-4 safe-bottom dark:bg-slate-900"
        onClick={(e) => e.stopPropagation()}
      >
        <div class="chat-col">
          <div class="mb-2 flex items-center justify-between">
            <h2 class="text-sm font-semibold text-slate-900 dark:text-white">{accountLabel}</h2>
            <button type="button" class="text-xs text-slate-400" onClick={onCancel}>
              {strings.cancel}
            </button>
          </div>
          <div class="divide-y divide-slate-100 dark:divide-slate-800">
            {OPTIONS.map((opt) => (
              <button
                key={opt.action}
                type="button"
                class="flex w-full items-start gap-3 py-3 text-left active:bg-slate-50 dark:active:bg-slate-800"
                onClick={() => onChoose(opt.action)}
              >
                <span class="mt-0.5 text-flux-primary dark:text-flux-cyan">
                  <Icon name={opt.icon} size={18} />
                </span>
                <span>
                  <span class="block text-sm text-slate-800 dark:text-slate-100">{opt.title}</span>
                  <span class="block text-xs text-slate-500 dark:text-slate-400">{opt.hint}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
